export default __webpack_public_path__ + "static/media/team4.61bdd3f7.jpg";